export const getRandomNote = scale => 
  scale[Math.floor(Math.random() * scale.length)]


// WEBPACK FOOTER //
// ./src/actions/helpers/getRandomNote.js